import React, { createContext, useState, useEffect } from 'react';

import { ApiFactory, fetchStaticData } from './ApiClient';

const API = ApiFactory.create();
// Create the context
const GlobalDataContext = createContext({
    loading: true,
    data: null as Awaited<ReturnType<typeof fetchStaticData>> | null,
    error: null as any
});

// Create a provider component
const GlobalDataProvider = ({ children }) => {
    const [data, setData] = useState<Awaited<ReturnType<typeof fetchStaticData>>>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        // console.log('fetching global data');
        try {
            const _data = await fetchStaticData();
            if (!_data) {
                console.log('No data fetched');
                return;
            }
            setData(_data);

        } catch (err) {
            setError(err);
        } finally {
            // console.log('fetching global data done');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [loading]);

    return (
        <GlobalDataContext.Provider value={{ data: data ? data : null, loading, error }}>
            {children}
        </GlobalDataContext.Provider>
    );
};

export { GlobalDataContext, GlobalDataProvider };